import { Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { TicketService } from '../services/ticket.service';

declare const html2canvas: any;

@Component({
  selector: 'app-debuger-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  protected URL = window.URL;

  support = {
    message: '',
    type: ''
  };
  active: boolean;
  screenshot: any;
  attachScreenshot = true;

  @Input() autoScreenshot: boolean;

  @ViewChild('previewImage') previewImage: ElementRef;
  @ViewChild('previewImageAutoScreenshot') previewImageAutoScreenshot: ElementRef;


  constructor(
    private _serviceTicket: TicketService,
    private toastrAlertHelper: ToastrAlertHelper,
  ) {
    this.autoScreenshot = true;
  }

  ngOnInit(): void {
    this.support.message = '';
  }

  patchValue(event): void {
    this.support.message = event.event.target.innerText;
  }

  open(): void {
    this.active = true;
    if (this.autoScreenshot) {
      html2canvas(document.body).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 0.40);
        this.previewImageAutoScreenshot.nativeElement.src = imgData;
        this.screenshot = imgData;
      });
    }
  }

  close(): void {
    this.active = false;
    this.support.message  = '';
    this.support.type = '';
  }

  toggleOpen(): void {
    if (this.active) {
      this.close();
    } else {
      this.open();
    }
  }

  send(): void {
    const img = this.attachScreenshot ? this.screenshot : undefined;
    this._serviceTicket.storeTicket(this.support, img);
    this.close();
  }

  /**
   * @description Importar foto
   * @param img
   */
  importImage(img: any): void {
    const files = img.srcElement.files;

    if (files && files.length) {
      const file = files[0];
      if (/^image\/\w+$/.test(file.type)) {

        const reader  = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          this.previewImage.nativeElement.src = reader.result;
          this.screenshot = reader.result;
        };

        reader.onerror = function (error) {
        };

      } else {
        this.toastrAlertHelper.warning('use jpg and / or png formats', 'Format not allowed');
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/debuger-app/ticket-support/support.component.ts